import React, { FC } from 'react'
import styled from '@emotion/styled'

import { PageWrapper } from '../../../components'

import imgTwitter from '../assets/twitter.png'
import imgInstagram from '../assets/instagram.png'
import imgYoutube from '../assets/youtube.png'

export const Footer: FC = () => (
    <FooterWrapper>
        <ContainerWrapper>
            <Join>Join our community to get Updates and Special Discounts on our New Arrivals.</Join>
            <div className="flex justify-center" style={{ marginTop: '20px' }}>
                <a href="https://twitter.com/metasill" target="_blank" rel="noopener noreferrer">
                    <Icon src={imgTwitter} alt="" />
                </a>
                <a
                    className="ml-4"
                    href="https://www.instagram.com/metasill.io/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Icon src={imgInstagram} alt="" />
                </a>
                <a
                    className="ml-4"
                    href="https://www.youtube.com/channel/UCgqvyRcw0ZFtFU_PaAAR2kw"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Icon src={imgYoutube} alt="" />
                </a>
            </div>
        </ContainerWrapper>
    </FooterWrapper>
)

const FooterWrapper = styled.div`
    background-color: #2f2e2e;
    padding: 30px 0;
`

const ContainerWrapper = styled(PageWrapper)`
    margin: 0 auto;
`

const Icon = styled.img`
    width: 24px;
    height: 24px;
`

const Join = styled.div`
    font-family: HelveticaNeue-Bold;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 24px;
`
